import { QRCodeSVG } from '@akamfoad/qrcode';

class QRCode extends HTMLElement {
    constructor() {
        super();
        this.value = ""
        this._root = this.attachShadow({mode: 'open'});
    }

    setValue(value) {
        this.value = value
        this.render()
    }

    static get observedAttributes() {
        return ['value'];
    }

    attributeChangedCallback(name, oldValue, newValue) {
        if (name === 'value') {
            this.setValue(newValue);
        }
    }

    render() {
        if (this.value.length < 1) {
            return
        }
        const code = new QRCodeSVG(this.value);
        this._root.innerHTML = code.toString() + `
            <style>
            /*
                qr-code {
                    aspect-ratio: 1 / 1;
                    display: block;
                }
             */
                svg {
                    max-width: 100%
                    max-height: 100%; /* Maximum height of the SVG is 100% of qr-code */
                    height: auto; /* Maintain the aspect ratio */
                    width: auto; /* Maintain the aspect ratio */
                }
            </style>`
    }
}

window.customElements.define('qr-code', QRCode);
